import { countryOptions } from '@common/country';
import { InputMask } from '@components/atoms';

import { DatePicker, Form, Input, Radio, Select } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

interface FormPersonalDataProps {
  prefix: string;
  isSpouse?: boolean;
}

export const FormPersonalData = ({
  prefix,
  isSpouse = false,
}: FormPersonalDataProps) => {
  const birthday = Form.useWatch([prefix, 'birthday']);
  const [age, setAge] = useState<string>('');

  useEffect(() => {
    if (birthday) {
      const years = dayjs().diff(birthday, 'year');
      setAge(`${years} years`);
    } else {
      setAge('');
    }
  }, [birthday]);

  return (
    <>
      <Form.Item
        label='Full name'
        name={[prefix, 'name']}
        rules={[{ required: true, message: 'This field is required' }]}
      >
        <Input placeholder='Enter the full name' />
      </Form.Item>

      <div className='grid grid-cols-1 md:grid-cols-2 md:gap-x-6'>
        <div className='flex gap-4 items-start w-full'>
          <Form.Item
            label='Date of birth'
            name={[prefix, 'birthday']}
            rules={[{ required: true, message: 'This field is required' }]}
            className='flex-1'
          >
            <DatePicker
              placeholder='MM/DD/YYYY'
              className='w-full'
              format={{
                format: 'MM/DD/YYYY',
                type: 'mask',
              }}
              inputReadOnly={true}
              open={false}
              onChange={(date) => {
                if (date) {
                  const years = dayjs().diff(date, 'year');
                  setAge(`${years} years`);
                } else {
                  setAge('');
                }
              }}
            />
          </Form.Item>

          {age && (
            <Form.Item
              label='Age'
              className='mt-[32px]'
            >
              <Input
                value={age}
                disabled
                className='bg-gray-50 border-gray-200'
              />
            </Form.Item>
          )}
        </div>

        <Form.Item
          label='Gender'
          name={[prefix, 'gender']}
          rules={[{ required: true, message: 'This field is required' }]}
        >
          <Radio.Group>
            <Radio value='male'>Male</Radio>
            <Radio value='female'>Female</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label='CPF'
          name={[prefix, 'cpf']}
        >
          <InputMask size='large' placeholder='000.000.000-00' mask='cpf' />
        </Form.Item>

        <Form.Item
          label='Country of origin'
          name={[prefix, 'nationality']}
        >
          <Select
            placeholder='Select the country of origin'
            size='large'
            options={countryOptions}
          />
        </Form.Item>

        <Form.Item
          label='Phone'
          name={[prefix, 'phone']}
        >
          <InputMask mask='phone' placeholder='Enter the phone number' />
        </Form.Item>

        <Form.Item
          label='E-mail'
          name={[prefix, 'email']}
        >
          <Input placeholder='Enter the email' type='email' />
        </Form.Item>

        <Form.Item label='Occupation' name={[prefix, 'profession']}>
          <Input placeholder='Enter the occupation' />
        </Form.Item>

        <Form.Item label='Monthly income' name={[prefix, 'monthlyIncome']}>
          <InputMask mask='money' placeholder='R$ 0,00' />
        </Form.Item>

        <Form.Item label='Marital status' name={[prefix, 'maritalStatus']} rules={[{ required: true, message: 'This field is required' }]}>
          <Select
            placeholder='Select the marital status'
            size='large'
            options={[]}
            disabled={isSpouse}
          />
        </Form.Item>
      </div>
    </>
  );
};
